import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { TagsEdit } from 'components/Settings/Components/Tags/components/tagsEdit';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const TagsEditPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.tagsEdit.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.tags.title} showBack={true} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <TagsEdit />
            </MainContent>
        </PageContainer>
    );
};
